import {
    ADD_POST,
    REMOVE_POST,
    UPDATE_POST,
    RESET_POSTS,
    SET_SELECTED_POST,
    TOGGLE_POST_SELECTION,
    RECEIVER_USER_DETAILS,
    RECEIVER_CHOOSED_PLATEFORM,
    SHOW_GIFT_DESIGN_PANEL,
    IS_USER_WANT_DESIGN_GIFTCARD,
    HIDE_GIFT_DESIGN_PANEL
} from './actionTypes.js';

/**
 * Adds a new post and automatically selects it if it's the first post
 * @param {Object} post - The post object to add
 * @param {boolean} [selectImmediately=false] - Whether to select this post immediately
 * @returns {Object} Action object
 */
export const addPost = (post, selectImmediately = false) => ({
    type: ADD_POST,
    payload: {
        ...post,
        // Add selection flag if needed
        ...(selectImmediately && { isSelected: true })
    }
});

/**
 * Removes a post by ID
 * @param {string|number} id - ID of the post to remove
 * @returns {Object} Action object
 */
export const removePost = (id) => ({
    type: REMOVE_POST,
    payload: id
});

/**
 * Updates a post's properties
 * @param {string|number} id - ID of the post to update
 * @param {Object} updates - New properties to merge
 * @returns {Object} Action object
 */
export const updatePost = (id, updates) => ({
    type: UPDATE_POST,
    payload: { id, updates }
});

/**
 * Resets all posts to initial state
 * @returns {Object} Action object
 */
export const resetPosts = () => ({
    type: RESET_POSTS
});

/**
 * Explicitly selects a post by ID
 * @param {string|number} id - ID of the post to select
 * @returns {Object} Action object
 */
export const setSelectedPost = (post) => ({
    type: SET_SELECTED_POST,
    payload: post
});

/**
 * Toggles a post's selection state
 * @param {string|number} id - ID of the post to toggle
 * @returns {Object} Action object
 */
export const togglePostSelection = (id) => ({
    type: TOGGLE_POST_SELECTION,
    payload: id
});

// Optional: Add a convenience action for setting default cover
export const setDefaultCover = (post) => addPost(post, true);


export const saveReceiverUserDetails = (payload) => ({
    type: RECEIVER_USER_DETAILS,
    payload: payload
});

export const userSelectedPlateform = (payload) => ({
    type: RECEIVER_CHOOSED_PLATEFORM,
    payload: payload
});

export const isUserWantDesignGiftCard = (payload) => ({
    type: IS_USER_WANT_DESIGN_GIFTCARD,
    payload: payload
});

export const showGiftDesignPanel = () => ({
    type: SHOW_GIFT_DESIGN_PANEL,
    payload: true
});

export const hideGiftDesignPanel = () => ({
    type: HIDE_GIFT_DESIGN_PANEL,
    payload: false
});
